export default __webpack_public_path__ + "img/slide3-remote.3a8cc8ea.png";